/* eslint-disable max-len */
import React, { useContext } from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import { useParams, useHistory } from "react-router-dom";

import ResponderTable from "@/components/Table/ResponderTable";
import HeaderComponent from "@/components/Header/Header";
import { usePanicTypes } from "@/hooks/usePanicTypes";
import {
  useAllResponderCompanies,
  useResponderAdmin,
} from "@/hooks/useResponderCompany";
import AllResponderTable from "@/components/Table/AllResponderTable";
import AuthContext from "@/contexts/AuthContext";

const { TabPane } = Tabs;

type responderParams = {
  companyId: string;
};

const AllResponders = () => {
  const history = useHistory();
  const { user, isAdmin } = useContext(AuthContext);
  const { companyId } = useParams<responderParams>();

  const panicTypes = usePanicTypes();
  // Will fetch from the backend
  const { data: companies } = useAllResponderCompanies();
  const { data: currentResponderAdmin } = useResponderAdmin(user?.id);
  // Will fetch from the backend
  const responderCompany: IResponderCompany | undefined | null =
    currentResponderAdmin?.responderCompany;

  console.log("currentResponderAdmin", currentResponderAdmin);

  const onTabChange = (key: string) => {
    if (isAdmin) {
      if (key.toLowerCase() === "all") {
        history.replace(`/home/All-responders`);
        return;
      }
      history.replace(`/home/All-responders/${key}`);
    } else {
      console.log(
        "getting `/home/responders/${responderCompany?.id}`",
        `/home/responders/${responderCompany?.id}`
      );
      history.replace(`/home/responders/${responderCompany?.id}`);
    }
  };

  return (
    <div className="flex w-full h-full bg-backgroundColor">
      <div className="w-full h-full max-h-screen overflow-y-auto disable-scrollbars">
        <HeaderComponent title="All Responders" />
        <Tabs
          defaultActiveKey={companyId || "0"}
          className="px-3"
          onChange={onTabChange}
        >
          <TabPane tab="All" key="0">
            <AllResponderTable companyId={0} />
          </TabPane>
          {isAdmin ? (
            <>
              {companies?.map((company: any) => (
                <TabPane tab={company.companyName} key={company.id.toString()}>
                  <AllResponderTable companyId={company.id} />
                </TabPane>
              ))}
            </>
          ) : (
            <>
              {currentResponderAdmin?.responderCompany?.EmergencyResponders?.map(
                (responder: any) => (
                  <TabPane
                    tab={currentResponderAdmin?.responderCompany?.companyName}
                    key={currentResponderAdmin?.responderCompany?.id.toString()}
                  >
                    <AllResponderTable
                      companyId={
                        currentResponderAdmin?.responderCompany?.id ?? 0
                      }
                    />
                  </TabPane>
                )
              )}
            </>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default AllResponders;
